<template>
  <v-page-content>
    <div>
      <div class="headerButtons">
        <div
          v-if="(hasRole(roles_.teacher) || hasRole(roles_.curator)) && !editMode"
          class="teacherButtons d-flex justify-content-start"
        >
          <b-button
            class="teacherButton teacherButtons__invitationsButton mr-2"
            v-if="hasRole(roles_.teacher)"
            variant="outline-primary"
            v-b-modal.courseInvitations
            :disabled="status !== statusFilters_.accepted"
          >
            <em class="fas fa-user-check"></em>
            Приглашения
          </b-button>
          <b-link to="students-progress" append>
            <b-button
              class="teacherButton teacherButtons__progressButton"
              variant="outline-primary"
              :disabled="status !== statusFilters_.accepted"
            >
              Прогресс учеников
            </b-button>
          </b-link>
        </div>
      </div>
      <div v-if="editMode && !isLoading" class="d-flex justify-content-end">
        <!-- Кнопки статус / удалить / сохранить / редактировать -->
        <b-button-toolbar>
          <b-button-group>
            <b-button
              variant="primary"
              :pressed="true"
              class='mr-2'>
              <em class="fas fa-info"/> Статус: {{ status }}
            </b-button>
            <b-button
              variant="outline-primary"
              :disabled="isRemoved"
              class="mr-2"
              v-b-modal.my-modal.delete-confirmation-modal
            >
              <em class="fa fa-1x fa-times"></em> Удалить
            </b-button>
            <b-button
              variant="outline-primary"
              @click="onSaveClick()"
              :disabled="isContentSaved || isWaiting
                || content.contentObject.title === null || content.contentObject.title.length === 0"
              class="mr-2"
            >
              <em class="far fa-1x fa-save"></em> Сохранить
            </b-button>
            <b-button
              variant="outline-primary"
              @click="onEditMode()"
              class="mr-2"
              :disabled="isWaiting"
            >
              <em :class="isEditMode ? 'far fa-edit' : 'fas fa-pen'"/>
              {{ isEditMode ? ' Режим просмотра' : ' Редактировать' }}
            </b-button>
            <b-button
              variant="outline-primary"
              @click="onClose"
            >
              <em class="fas fa1-x fa-times-circle"/> Закрыть
            </b-button>
          </b-button-group>
        </b-button-toolbar>

        <modal-delete-confirmation :deleteHandler="onDeleteCourse"/>
      </div>
      <b-alert
        v-if="!isLoading"
        :show="validationErrorAlert"
        @dismissed="validationErrorAlert=false"
        dismissible
        class="mt-3"
        variant="danger">
        Ошибка сохранения. Проверьте корректность заполнения курса
      </b-alert>
      <div v-if="!isLoading && content && content.contentObject">
        <!-- Информация о курсе в режиме просмотра -->
        <div v-if="!isEditMode">
          <div v-if="!$route.path.includes('content')">
            <b-button v-if="!isMember" variant="primary"
                      class="float-right" @click="applyOnCourse">Поступить на курс
            </b-button>
            <b-button v-if="isMember && !isSCORM" variant="primary"
                      class="float-right" @click="gotoCourse">Продолжить обучение
            </b-button>
          </div>
          <h2 class='mt-3'>
            {{ content.contentObject.title ? content.contentObject.title : 'Название отсутствует' }}
          </h2>
          <b-row v-if="!isSCORM || !isMember" no-gutters>
            <b-col md="4" sm="12" class='img-col'>
              <b-card-img width="300" :src="avatar" class="rounded-0"/>
            </b-col>
            <b-col md="8" sm="12">
              <div class='text-justify pl-2' v-html="content.contentObject.shortDescription"/>
            </b-col>
          </b-row>
          <!-- Цикл по темам-->
          <template v-if="!isSCORM">
            <b-card
              v-for="(topic, index) in content.topics.filter((t) => t.sections && t.sections.length)"
              :key="topic.id"
              class="mt-2 p-0"
              no-body
            >
              <b-card-header class="p-0">
                <b-button
                  squared
                  class="card w-100"
                  variant="outline-primary"
                  @click="() => openTopicCollapse(topic.id)"
                >
                  <div class="card-body py-3 d-flex justify-content-between w-100">
                    <div class="text-left">{{ topic.title }}</div>
                    <em
                      :class="`fas fa-lg fa-angle-${
                      openedCollapses.includes(`collapse-for-topics-${topic.id}`)
                      ? 'up'
                      : 'down'
                    } ml-2 d-block align-self-center`"/>
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse :id="`collapse-for-topics-${topic.id}`">
                <b-card-body class="py-0">
                  <div v-for="(section, sectionIndex) in topic.sections"
                       :key="section.id" class="my-2">
                    <b-link @click="onGoToSection(section, topic.title === 'Тестирование')">
                      <b-card variant="outline-secondary">
                        <b-row no-gutters>
                          <b-col cols="11">
                            <b-card-text>{{ section.title }}</b-card-text>
                          </b-col>
                          <b-col>
                            <b-badge v-if="section.subSections && (topic.title !== 'Тестирование')"
                                     :variant="getSectionElementPassed(index, sectionIndex)
                            === section.subSections.length ? 'primary' : 'secondary' ">
                              {{ getSectionElementPassed(index, sectionIndex) }}
                              / {{ section.subSections.length }}
                            </b-badge>
                            <b-badge v-if="topic.title === 'Тестирование'"
                                     :variant="section.isCreatedByTeacher ? 'secondary' : 'primary'"
                                     :title="section.isCreatedByTeacher
                                 ? 'Создан классным руководителем'
                                 : 'Создан контент-менеджером'"
                            >
                              {{ section.isCreatedByTeacher ? 'КР' : 'КМ' }}
                            </b-badge>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-link>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </template>
          <div class="mt-3" v-if="hasRole(roles_.content)">
            <content-accept :beforeSendToVerification="onSaveClick"/>
          </div>
        </div>
        <!-- Информация о курсе в режиме редактирования -->
        <div v-else>
          <h4>Название</h4>
          <b-form-input
            :value="content.contentObject.title"
            placeholder="Введите название"
            @input="onTitleChange"/>
          <b-form-invalid-feedback
            :force-show="isEditMode ? content.contentObject.title === null : false"
          >
            Заголовок не может быть пустым
          </b-form-invalid-feedback>
          <div class='mt-3'>
            <img
              id="avatar-image"
              :src="avatar"
              @click="onChangeAvatar"
              @error="$event.target.src = defaultImage"
              alt="Аватар"
              class="mb-3"
              height="190px"
              width="300px"
            >
            <b-button
              @click="onDeleteAvatar"
              v-b-tooltip.hover
              title="Удалить аватар"
              variant="primary"
              class="fa fa-times position-relative"
              style="top: -80px; right: 45px;"/>
            <b-button
              @click="onChangeAvatar"
              v-b-tooltip.hover
              title="Изменить аватар. Поддерживаемые форматы: .jpg, .png"
              variant="primary"
              class="fa fa-edit position-relative"
              style="top: -80px; right: 130px;"
            />
          </div>
          <h4>Краткое описание</h4>
          <wysiwyg-text-editor dataType="courseShortDescription"/>
          <!-- Содержание курса. Цикл по темам -->
          <div class="mt-4" v-if="!isSCORM">
            <h4 class="d-inline">Содержание</h4>
            <b-button
              variant="outline-primary"
              class="ml-3 mb-2"
              @click="onAddTopic"
            >
              <em class="fas fa-plus mr-1"/> Добавить тему
            </b-button>
          </div>
          <draggable-topics
            :invalid-sections="invalidSections"
            :invalid-topics="invalidTopics"
            @title-topic="onTopicTitleChange"
            @title-section="onSectionTitleChange"
            @move-topic="onMoveTopic"
            @move-section="onSectionMoved"
            @add-section="onAddSection"
            @delete-topic="onDeleteTopic"
            @delete-section="onDeleteSection"
          />
          <!-- Модальное окно для загрузки аватарки курса -->
          <v-modal-files-upload wrkspcType="avatar" :fileHandler="fileHandler"/>
          <!-- Модальное окно для удаления раздела / темы -->
          <delete-section-modal
            :topic="topicToDelete"
            :section="sectionToDelete"
            @delete="onSectionDeleteClicked"
          />
          <div class="mt-3">
            <content-accept :beforeSendToVerification="onSaveClick"/>
          </div>
        </div>
        <div v-if="isSCORM && isMember" id="scorm-container">
          <iframe
            v-if="scormPath"
            :src="scormPath"
            width="100%"
            height="700"
            frameborder="0"
            id="scorm-frame"
          ></iframe>
        </div>
      </div>
      <div v-else class="d-flex justify-content-center mb-3">
        <b-spinner variant="primary"
                   style="width: 5cm; height: 5cm;"
                   label="Загрузка..."></b-spinner>
      </div>
      <course-invitations
        v-if="hasRole(roles_.teacher)"
        @closeEventModal="closeCourseInvitationsModal"
        @courseInvitationsWereSent="closeCourseInvitationsModal"
      >
      </course-invitations>
    </div>
  </v-page-content>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ContentAccept from '@/components/content/verification/ContentAccept.vue'
import ModalDeleteConfirmation from '@/components/content/edit/modals/ModalDeleteConfirmation.vue'
import WysiwygTextEditor from '@/components/content/edit/WysiwygTextEditor.vue'
import CourseInvitations from '@/components/content/education/courses/modals/CourseInvitations.vue'
import VModalFilesUpload from '@/components/content/edit/modals/ModalFilesUpload.vue'
import RouteMixin from '@/components/helpers/mixins/route-mixin'
import DeleteSectionModal from '@/components/content/education/courses/modals/DeleteSectionModal.vue'
import DraggableTopics from '@/components/content/education/courses/DraggableTopics.vue'
import { roles } from '@/config/roles'
import { statusFilters } from '@/config/content/statuses'

const scorm = require('scorm-again')

export default {
  name: 'CourseBookContent',
  components: {
    DraggableTopics,
    DeleteSectionModal,
    ModalDeleteConfirmation,
    WysiwygTextEditor,
    CourseInvitations,
    VModalFilesUpload,
    ContentAccept
  },
  mixins: [RouteMixin],
  props: {
    editMode: Boolean
  },
  beforeRouteLeave(to, from, next) {
    if (this.$_isLeavingCourse(to)) {
      this.isLoading = true
      this.clearCourseContent()
    }
    next()
  },
  mounted() {
    this.$root.$on('bv::collapse::state', (id, status) => {
      const index = this.openedCollapses.indexOf(id)
      if (status && index === -1) {
        this.openedCollapses.push(id)
      } else if (!status && index > -1) {
        this.openedCollapses.splice(index, 1)
      }
    })
    this.resetTestingModes()
    if (!this.content || !this.content.contentObject || this.content.id !== Number(this.courseId)) {
      this.fetchCourseContent({
        id: this.courseId,
        all: this.editMode
      }).then(() => {
        this.afterContentFetch()
      })
    } else {
      this.afterContentFetch()
    }
    this.updateUpdater(0)
    this.updateContentSavedStatus(true)
    window.onbeforeunload = false
    this.clearCourseChanges()
    this.setEditMode(false)
  },
  data() {
    return {
      statusFilters_: statusFilters,
      roles_: roles,
      isLoading: true,
      scormNoTest: false,
      isSCORM: false,
      lastSentScore: -1.0,
      lastSentStatus: '',
      result: 0,
      scormPath: '',
      isEditMode: false,
      isWaiting: false, // ?
      defaultImage: '/images/w1400_1.jpg',
      topicToDelete: null,
      sectionToDelete: null,
      invalidTopics: {},
      invalidSections: {},
      validationErrorAlert: false,
      openedCollapses: []
    }
  },
  methods: {
    ...mapActions({
      sendSCORMResult: 'education/sendSCORMResult',
      deleteCourse: 'education/deleteCourse',
      fetchSelectedContent: 'content/fetchSelectedContent',
      fetchCourseContent: 'education/fetchCourseContent',
      updateUpdater: 'contentManager/updateUpdater',
      updateCourse: 'education/updateCourse',
      applyCourseChanges: 'education/applyCourseChanges',
      clearCourseContent: 'education/clearCourseContent',
      applyOnCourse: 'education/applyOnCourse',
      pushToasts: 'toasts/pushToasts',
      resetTestingModes: 'test/resetTestingModes'
    }),
    ...mapMutations({
      updateCourseContent: 'education/updateCourseContent',
      updateContentSavedStatus: 'contentManager/updateContentSavedStatus',
      updateCourseTopicTitle: 'education/updateCourseTopicTitle',
      moveCourseSection: 'education/moveCourseSection',
      deleteCourseTopic: 'education/deleteCourseTopic',
      updateCourseSectionTitle: 'education/updateCourseSectionTitle',
      deleteCourseSection: 'education/deleteCourseSection',
      addTopic: 'education/addTopic',
      addSection: 'education/addSection',
      setCourseAvatar: 'education/setCourseAvatar',
      deleteCourseAvatar: 'education/deleteCourseAvatar',
      setCoursePositions: 'education/setCoursePositions',
      clearCourseChanges: 'education/clearCourseChanges',
      setEditMode: 'contentManager/editMode'
    }),
    initScormAPI(vueThis) {
      const settings = {}

      window.API = new window.Scorm12API(settings)
      window.API_1484_11 = new window.Scorm2004API(settings)

      function addScormTrigger(api) {
        const originalSetValue = api.SetValue || api.LMSSetValue

        if (!originalSetValue) {
          return
        }

        function wrappedSetValue(key, value) {
          // Работает только для 5 теста (остальные случаи надо рассматривать отдельно)
          if (key === 'cmi.core.session_time' && vueThis.scormNoTest) {
            if (value !== '00:00:00') {
              vueThis.result = 1
              vueThis.sendSCORMResult({
                courseId: vueThis.courseId,
                scoreRaw: vueThis.result
              }).then(() => {
              }).catch(() => {
              })
            }
          }
          if ((key === 'cmi.core.score.raw' || key === 'cmi.score.raw') && vueThis) {
            vueThis.result = parseFloat(value)
          }

          if (
            (
              key.includes('cmi.core.lesson_status') || key.includes('cmi.success_status')
            )
            && ['passed', 'failed'].includes(value)
            && vueThis
          ) {
            const scoreChanged = vueThis.result !== vueThis.lastSentScore
            if ((scoreChanged) && vueThis) {
              vueThis.sendSCORMResult({
                courseId: vueThis.courseId,
                scoreRaw: vueThis.result
              }).then(() => {
                vueThis.lastSentScore = vueThis.result
              }).catch(() => {
              })
            }
          }

          return originalSetValue.call(this, key, value)
        }

        if (api.SetValue) api.SetValue = wrappedSetValue
        if (api.LMSSetValue) api.LMSSetValue = wrappedSetValue
      }

      addScormTrigger(window.API, 'SCORM 1.2')
      addScormTrigger(window.API_1484_11, 'SCORM 2004')
    },
    openTopicCollapse(id) {
      this.$root.$emit('bv::toggle::collapse', `collapse-for-topics-${id}`)
    },
    async onSaveClick() {
      this.validateAllTopics()
      if (Object.keys(this.invalidSections).length === 0
        && Object.keys(this.invalidTopics).length === 0
        && (this.content.contentObject.title.length > 0)) {
        this.isLoading = true
        this.updateUpdater(0)
        await this.updateCourse(this.courseId)
        await this.applyCourseChanges()
        await this.fetchCourseContent({ id: this.courseId, all: this.editMode })
        this.updateContentSavedStatus(true)
        this.isLoading = false
        this.isEditMode = false
        window.onbeforeunload = undefined
        this.validationErrorAlert = false
        this.setEditMode(false)
      } else {
        this.validationErrorAlert = true
      }
    },
    afterContentFetch() {
      if (this.status !== 'опубликовано' && this.hasRole(this.roles_.student)) {
        this.$router.push('/page_not_exist')
        return
      }
      this.isSCORM = this.content.isSCORM
      this.scormNoTest = this.content.scormNoTest
      this.scormPath = this.content.scormPath
      this.isLoading = false
      this.$nextTick(() => {
        if (this.isSCORM) {
          this.initScormAPI(this)
        }
      })
    },
    async onEditMode() {
      this.isEditMode = !this.isEditMode
      this.setEditMode(!this.storeIsEdit)
    },
    onUpdated() {
      this.updateUpdater(this.updater + 1)
      if (this.updater > 0) {
        this.updateContentSavedStatus(false)
      }
      window.onbeforeunload = () => 'Имеются несохранённые изменения. Вы точно хотите закрыть страницу?'
    },
    onTitleChange(title) {
      this.updateCourseContent({
        title
      })
      this.onUpdated()
    },
    fileHandler(files) {
      this.setCourseAvatar(files[0])
      this.onUpdated()
    },
    onDeleteAvatar() {
      this.deleteCourseAvatar()
      this.onUpdated()
    },
    onChangeAvatar() {
      this.$bvModal.show('files-upload-modal')
    },
    async onDeleteCourse() {
      await this.deleteCourse(this.courseId)
      this.$bvModal.hide('delete-confirmation-modal')
      this.$router.push('./')
    },
    onGoToSection(section, param) {
      const link = this.getSectionUrl(section, param)
      if (this.hasRole('student') && !this.isMember) {
        this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: 'Вы не являетесь участником этого курса',
          time: 3
        })
      } else {
        this.$router.push(link)
      }
    },
    onAddTopic() {
      this.onUpdated()
      this.addTopic(this.courseId)
      this.validateAllTopics()
    },
    onAddSection(internalId) {
      this.onUpdated()
      this.addSection(internalId)
      this.validateTopic(this.content.topics[internalId])
    },
    onTopicTitleChange(data) {
      this.onUpdated()
      this.validateTopic(data.topic, data.newTitle)
      this.updateCourseTopicTitle({ internalId: data.index, newTitle: data.newTitle })
    },
    onMoveTopic(data) {
      this.onUpdated()
      this.moveCourseSection({ internalId: data.index, direction: data.direction })
    },
    onSectionMoved() {
      this.validateAllTopics()
      this.onUpdated()
    },
    onSectionTitleChange(data) {
      this.onUpdated()
      const check = this.validateSectionTitle(data.newTitle)
      this.updateCourseSectionTitle({
        topicInternalId: data.topicIndex,
        sectionInternalId: data.sectionIndex,
        newTitle: data.newTitle
      })
      if (check) {
        this.$set(this.invalidSections, data.section.id, check)
      } else if (data.section.id in this.invalidSections) {
        delete this.invalidSections[data.section.id]
      }
    },
    ifTestingTopic(topic) {
      return (topic.title === 'Тестирование'
        && topic.id === this.content.topics[this.content.topics.length - 1].id)
    },
    validateAllTopics() {
      this.content.topics.forEach((topic) => this.validateTopic(topic))
    },
    validateTopic(topic, newTitle) {
      let error = null
      if (!topic.sections || topic.sections.length === 0) {
        error = 'В теме должен быть хотя бы один раздел'
      }
      if (newTitle !== undefined) {
        error = error || this.validateTopicTitle(newTitle, true)
      } else {
        error = error || this.validateTopicTitle(topic.title)
      }
      if (error && !this.ifTestingTopic(topic)) {
        this.$set(this.invalidTopics, topic.id, error)
        // this.invalidTopics[topic.id] = error
      } else if (topic.id in this.invalidTopics) {
        this.$set(this.invalidTopics, topic.id, undefined)
        delete this.invalidTopics[topic.id]
      }
    },
    validateTopicTitle(title, isNew) {
      let error = null
      if (title.length === 0) {
        error = 'Имя темы не может быть пустым'
      }
      if (title === 'Тестирование') {
        error = error || 'Имя "Тестирование" зарезервировано'
      }
      if (isNew && this.topicNames.includes(title)) {
        error = error || 'Имена тем не могут повторяться'
      }
      return error
    },
    validateSectionTitle(title) {
      let error = null
      if (title.length === 0) {
        error = 'Имя раздела не может быть пустым'
      }
      return error
    },
    onDeleteTopic(internalId) {
      this.sectionToDelete = null
      this.topicToDelete = internalId
      this.$bvModal.show('section-element-delete-modal')
    },
    onDeleteSection(data) {
      this.topicToDelete = data.topicIndex
      this.sectionToDelete = data.sectionIndex
      this.$bvModal.show('section-element-delete-modal')
    },
    onSectionDeleteClicked() {
      this.onUpdated()
      if (this.sectionToDelete !== null && this.topicToDelete !== null) {
        const { id } = this.content.topics[this.topicToDelete].sections[this.sectionToDelete]
        if (id in this.invalidSections) {
          delete this.invalidSections[id]
        }
        this.deleteCourseSection({
          topicInternalId: this.topicToDelete,
          sectionInternalId: this.sectionToDelete
        })
      } else if (this.topicToDelete !== null) {
        const { id } = this.content.topics[this.topicToDelete]
        if (id in this.invalidTopics) {
          delete this.invalidTopics[id]
        }
        this.deleteCourseTopic(this.topicToDelete)
      }
      this.$bvModal.hide('section-element-delete-modal')
      this.validateAllTopics()
    },
    onClose() {
      this.$router.push('./')
    },
    getSectionUrl(section, isTest) {
      return this.$_getSectionUrl(this.$route.path, this.content, section, isTest)
    },
    closeCourseInvitationsModal() {
      this.$bvModal.hide('courseInvitations')
    },
    gotoCourse() { // eslint-disable-line consistent-return
      if (this.$cookies.isKey(`ebook${this.content.id}`)) {
        const subSectionId = Number(this.$cookies.get(`ebook${this.content.id}`))
        this.content.topics.some((topic) => { // eslint-disable-line arrow-body-style
          return topic.sections.some((section) => { // eslint-disable-line arrow-body-style
            return section.subSections.some((subSection) => {
              if (subSection.id === subSectionId) {
                this.$router.push(this.$_getSubsectionUrl(this.$route.path,
                  this.content, section, subSection))
                return true
              }
              return false
            })
          })
        })
      } else {
        return this.$router.push(this.getSectionUrl(this.content.topics[0].sections[0]))
      }
    }
  },
  computed: {
    ...mapGetters({
      content: 'education/getCourseContent',
      contentData: 'content/getContent',
      isContentSaved: 'contentManager/isContentSaved',
      updater: 'contentManager/getUpdater',
      hasRole: 'currentUser/hasRole',
      getSectionElementPassed: 'education/getSectionElementPassed',
      topicNames: 'education/getTopicNames',
      getSectionNames: 'education/getSectionNames',
      isMember: 'education/getCourseMember',
      storeIsEdit: 'contentManager/isEditMode'
    }),
    courseId() {
      return this.$route.params.courseBookId
    },
    avatar() {
      let avatar = this.defaultImage
      if (this.content && this.content.contentObject.avatar) {
        avatar = `/api/files/${this.content.contentObject.avatarFile.physicalName}`
      }
      return avatar
    },
    status() {
      if (this.content && this.content.contentObject) {
        return this.content.contentObject.status
      }
      return ''
    },
    isRemoved() {
      return this.status === this.statusFilters_.removed
    },
    isDraft() {
      return this.status === this.statusFilters_.draft
    }
  }
}
</script>

<style scoped>
.img-col {
  width: 300px;
}

.headerButtons {
  width: 100%;
  padding: 20px 10px 5px 10px;
}


</style>
